import {
  IPartnerSubmissionClientView,
  OfferQuality,
  PartnerSubmissionState,
} from "../services/nswag/clients/loanApplicationsClient";

const qualityOrder: { [id: string]: number } = {
  [OfferQuality.None]: 0,
  [OfferQuality.LowestCostPerPeriod]: 1,
  [OfferQuality.LowestEffectiveInterestRate]: 2,
  [OfferQuality.LowestCostAndLowestEffectiveRate]: 3,
};

export const comparePartnersByOfferQuality = (
  a: IPartnerSubmissionClientView,
  b: IPartnerSubmissionClientView
) => {
  const qa = Math.max(
    qualityOrder[a.primaryOffer?.quality ?? OfferQuality.None],
    qualityOrder[a.dualOffer?.quality ?? OfferQuality.None]
  );
  const qb = Math.max(
    qualityOrder[b.primaryOffer?.quality ?? OfferQuality.None],
    qualityOrder[b.dualOffer?.quality ?? OfferQuality.None]
  );
  return qb - qa;
};

export const hasQuality = (partner: IPartnerSubmissionClientView) => {
  const a =
    partner.primaryOffer?.quality &&
    partner.primaryOffer?.quality !== OfferQuality.None;
  const b =
    partner.dualOffer?.quality &&
    partner.dualOffer?.quality !== OfferQuality.None;
  return a || b;
};

export const getEffectiveInterest = (partner: IPartnerSubmissionClientView) => {
  const a = partner.primaryOffer?.effectiveInterest ?? Number.MAX_VALUE;
  const b = partner.dualOffer?.effectiveInterest ?? Number.MAX_VALUE;
  return Math.min(a, b);
};

export const sortOffersByOffer = (partners: IPartnerSubmissionClientView[]) => {
  const wQuality = partners
    .filter((p) => hasQuality(p))
    .sort(comparePartnersByOfferQuality);
  const woQuality = partners
    .filter(
      (p) => p.state === PartnerSubmissionState.OfferGiven && !hasQuality(p)
    )
    .sort((p) => getEffectiveInterest(p));
  const pending = partners.filter(
    (p) =>
      p.state !== PartnerSubmissionState.OfferGiven &&
      p.state !== PartnerSubmissionState.RejectedByPartner &&
      p.state !== PartnerSubmissionState.SubmissionFailed
  );
  const rejected = partners.filter(
    (p) => p.state === PartnerSubmissionState.RejectedByPartner
  );

  return [...wQuality, ...woQuality, ...pending, ...rejected];
};
